import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-popup-redirect',
    templateUrl: './popup-redirect.component.html',
    styleUrls: ['./popup-redirect.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class PopupRedirectComponent implements OnInit {

    constructor(private readonly route: ActivatedRoute) { }

    ngOnInit() {
        this.redirectWithDelay();
    }

    redirectWithDelay() {
        setTimeout(() => window.location.href = this.route.snapshot.queryParamMap.get('url'), 3000);
    }
}
